var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"1d2feb21d944e4dc2f0edf6abc021d1b5c7d7fe8"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["kfh-gatsby@fresh-egg-limited"]={id:"1d2feb21d944e4dc2f0edf6abc021d1b5c7d7fe8"};
      